/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-disable max-lines, max-statements */
// TODO #169 Refaktorizovat adaptéry a device.

import EventEmitter from 'eventemitter3';
import isNil from 'lodash/isNil';

import CommandEnum from '../core/command-enum';

// TODO #44 Dopsat E2E testy pro update. Jak nastavovat na serveru?
// TODO #93 Plán:
// - Installer: Algoritmus spuštění zařízení:
//   - pokud je zařízení již spuštěné, vyhodit chybu.
//   - start adaptéru (naslouchání teplotě apod.)
//   - detekce platformy (pro aktualizaci apod.)
//   - obnovení hodnot z datového skladu (JSON + binární)
//   - pokud zařízení není nainstalované, tak se zobrazí setup wizard a do jeho vyplnění se nic dále neprovádí. Po odeslání se zařízení začne připojovat.
//   - pokud již zařízení někdy obdrželo obsah, tak se zobrazí poslední kompletně načtený.
//      - To může být prolínač, ale také třeba černá obrazovka, pokud byl takto obsah při vypnutí nastaven.
//   - jinak se zobrazuje načítací animace, dokud se nepodaří poprvé kompletně načíst obsah.
//   - spuštění připojení zařízení
// - Communicator: Algoritmus připojení zařízení (serverUrl, deviceId):
//   - pokud je zařízení již připojené, vyhodit chybu.
//   - naplánovat provádění heartbeat opakovaně v intervalu bez ohledu na výsledek.
//   - provedení prvního heartbeat.
// - CommunicatorHeartbeat: Algoritmus provedení heartbeat:
//   - pokud se již nějaký heartbeat provádí, tak tuto iteraci nedělat nic.
//   - stažení heartbeat
//   - porovnají se přijaté hodnoty s předchozími a v případě změn se spouští paralelně:
//     - provedení aktualizace (mělo by být jasné)
//     - spuštění příkazů (mělo by být jasné)
//     - stažení JSON obsahu.
// - ContentCommunicator: Algoritmus stahování JSON obsahu (contentTimestamp):
//   - uložení nejnovějšího požadovaného contentTimestamp.
//   - pokud se již nějaký obsah stahuje, tak se již nic jiného nedělat.
//   - stažení JSON obsahu
//   - pokud stažení neuspěje, nebo načtený JSON obsah neodpovídá uloženému contentTimestamp (tj. nejnovější požadovaný během stahování)
//       - počkat určitý počet vteřin a pak opakovat stažení.
//   - uložení dat z JSON obsahu do samostatného datového skladu contentStore.
//   - stažení binárních souborů.
// - Downloader: Algoritmus stahování binárního obsahu (contentStore):
//   - pokud se již nějaký obsah stahuje, tak se vyžádá jeho přerušení (a vymazání?), potom se pokračuje.
//   - (sériové?) stažení všech potřebných souborů z contentStore na disk zařízení, neuspěšné (URL neexistuje, není místo na disku...) se ignorují.
//   - narozdíl od JSON obsahu je zde datové úložiště binárních souborů sdílené s aktuálně přehrávaným obsahem (nestahuje se znova, jen se přidávají nové).
//   - výměna obsahu.
// - Replacer: Algoritmus výměny obsahu (contentStore):
//   - nahrazení nyní kompletně staženého contentStore za aktuálně přehrávaný obsah.
//   - zobrazení nového obsahu.
//   - označení starého binárního obsahu pro možné uvolnění při garbage collection?
// TODO #93 Struktura:
// - Installer
// - Communicator
//   - CommunicatorHeartbeat
//   - ContentCommunicator
// - Replacer
//   - Downloader
// - Commander
// - Updater
// - Reporter
// TODO #458 Vyčlenit logiku řízení prolínače z Device do ViewerManager.
// - Vytvořit ViewerManager:
//   - constructor (scheduleManager, viewerDirectorResource, viewerRegistry)
//   - createDirector(): ViewerDirector
//   - destroyDirector(director): undefined
//   - setTask(contentTask): Promise.<undefined>
// - Zatím není implementováno, protože by to vyžadovalo moc změn v současné logice.
//   Raději je zachována současná logika se specifickými reakcemi na různé změny.
//   Asi by bylo vhodné přidružit k nějaké promyšlené top-level reorganizaci.
// - Za začátku je zde prázdný obsah.
//   Během startu se obsah obnoví z localStorage.
//   Dále se aktualizuje dle změn obsahu z komunikátoru.
//   Obsah je kdykoliv připraven, aby z něj mohlo být plánováno přehrávání.
// - Je důležité, aby byly plánovací strategie vytvářeny pro každý prolínač samostatně.
//   Když by zde byly dva ViewerDirector, tak by si vzájemně přeskakovali média.
//   Také jejich stavy budou odlišné, když záleží na době fyzického přehrání média,
//   nebo také mohou různě přeskakovat média kvůli vyčerpání zdrojů.
//   Vždy se tedy uchovává aktuální obsah a až on-demand se vytváří nová sada strategií.
/**
 * Zařízení, které posktytuje služby pomocí libovolného adaptéru.
 * Do budoucna z něj bude vyčleněna třída Client, která bude poskytovat část jeho rozhraní přes MessageChannel.
 * @implements {EventBus}
 */
class Device {
  /**
   * Vytvoří instanci.
   * @param {string} [buildId]
   * @param {AnalyticsTracker} analyticsTracker
   * @param {Communicator} communicator
   * @param {ContentTaskCronFactory} contentTaskCronFactory
   * @param {FingerprintManager} fingerprintManager
   * @param {FirmwareManager} firmwareManager
   * @param {Logger} logger
   * @param {LoggerManager} loggerManager
   * @param {NetworkListener} networkListener
   * @param {PowerManager} powerManager
   * @param {Replacer} replacer
   * @param {ReportManager} reportManager
   * @param {ScheduleManager} scheduleManager
   * @param {Session} session
   * @param {StartupManager} startupManager
   * @param {Store} store
   * @param {Updater} updater
   * @param {ViewerDirectorResource} viewerDirectorResource
   * @param {ViewerRegistry} viewerRegistry
   * @returns {Device}
   */
  constructor(
    buildId,
    analyticsTracker,
    communicator,
    contentTaskCronFactory,
    fingerprintManager,
    firmwareManager,
    logger,
    loggerManager,
    networkListener,
    powerManager,
    replacer,
    reportManager,
    scheduleManager,
    // TODO: Pozor na to, že i contentInfo nese session! Co je pak zdrojem pravdy?
    session,
    startupManager,
    // TODO: Pozor na to, že i contentInfo nese store! Co je pak zdrojem pravdy?
    store,
    updater,
    viewerDirectorResource,
    viewerRegistry
  ) {
    this.analyticsTracker = analyticsTracker;
    this.buildId = buildId;
    this.communicator = communicator;
    /**
     * Aktuální obsah, který se na zařízení přehrává.
     * Je `null` pouze před voláním {@link Device#start}.
     * @private
     * @type {ContentInfo|null}
     */
    this.contentInfo = null;
    /**
     * Aktuální plánovač úloh, která řídí změny v přehrávání.
     * Je `null` pouze před voláním {@link Device#start}
     * a mezi změnami obsahu, aby ho nepřerušil.
     * @private
     * @type {ContentTaskCron|null}
     */
    this.contentTaskCron = null;
    this.contentTaskCronFactory = contentTaskCronFactory;
    this.emitter = new EventEmitter();
    this.fingerprintManager = fingerprintManager;
    this.firmwareManager = firmwareManager;
    this.logger = logger;
    this.loggerManager = loggerManager;
    this.networkListener = networkListener;
    this.powerManager = powerManager;
    this.replacer = replacer;
    this.reportManager = reportManager;
    this.scheduleManager = scheduleManager;
    this.session = session;
    this.startupManager = startupManager;
    this.store = store;
    this.updater = updater;
    this.viewerDirectorResource = viewerDirectorResource;
    this.viewerRegistry = viewerRegistry;
    // Navázání naslouchání na instanci.
    this.onContentCleaned = this.onContentCleaned.bind(this);
    this.onContentTaskChanged = this.onContentTaskChanged.bind(this);
    this.onError = this.onError.bind(this);
    this.onHeartbeatFetched = this.onHeartbeatFetched.bind(this);
    this.onOnlineChanged = this.onOnlineChanged.bind(this);
    analyticsTracker.on('error', this.onError);
    networkListener.on('onlineChanged', this.onOnlineChanged);
    replacer.on('content', this.onContentCleaned);
  }

  /**
   * Zastaví přehrávání obsahu při čištění místa na disku.
   * @param {ContentInfo} contentInfo Prázdný obsah.
   * @private
   * @returns {Promise.<undefined>}
   */
  cleanContent(contentInfo) {
    // TODO #295 Hotfix zastavení obsahu před spuštěním čištění.
    // - Zrevidovat celou funkcionalitu. Není úplně 100% dokonalá a elegantní.
    // - Obecně se událost předává takto: Cleaner -> Downloader -> Replacer -> Device.
    // - Také by nemuselo posílat obsah, spíše požadavek na zastavení vláken prohlížeče.
    // - Narozdíl od běžné změny obsahu se neprovádí některé akce i když by možná měli.
    // - Také se zbytečně volá `createThreads`. Přeci jen je zde možnost, že by cleaner nějaký obah vložil.
    //   Přepracovat až s případnou refaktorizací čištění.
    return new Promise((resolve) =>
      resolve(
        // Zastaví se a zruší se CRON, aby změna úlohy nepřerušila změnu obsahu.
        this.unsetContentTasks()
          // Nastaví se nový (prázdný) obsah.
          // Během této změny obsahu se neuvolňují zdroje, ani se nepřepínají
          // analytické intervaly, jako u běžné změny obsahu.
          // Také se tato změna neprojeví v "content" události.
          .then(() => {
            this.contentInfo = contentInfo;
          })
          // Spustí se CRON s novým (prázdným) obsahem.
          .then(() => this.setContentTasks(contentInfo.contentTasks))
      )
    );
  }

  /**
   * Spustí kontinuální synchronizaci obsahu zařízení se spárovaným serverem.
   * @returns {Promise.<undefined>} Vyřeší se pod dokončení první synchronizace.
   */
  connect() {
    const { communicator, session } = this;
    // Naslouchání událostem.
    communicator.on('error', this.onError);
    communicator.on('heartbeatFetched', this.onHeartbeatFetched);
    return communicator.connect(
      session.serverUrl,
      session.deviceId,
      session.contentTimestamp
    );
  }

  /**
   * Vytvoří nový organizátor zobrazování obsahu.
   * @param {HTMLElement} el ELement, do kterého se prolínač vykresluje.
   * @returns {ViewerDirector}
   */
  createDirector(el) {
    const director = this.viewerDirectorResource.create(el);
    const { contentTaskCron } = this;
    // Pokud je dostupný CRON obsahových úloh, vytvoří se dle něj vlákna.
    if (!isNil(contentTaskCron)) {
      const contentTask = contentTaskCron.getCurrentTask();
      // Vytvoří se nové strategie na základě aktuálně přehrávané obsahové úlohy.
      const scheduleStrategyArray = this.scheduleManager.createStrategies(
        contentTask,
        this.contentInfo
      );
      // Na výsledek se nečeká, kvůli zpětné kompatibilitě,
      // aby mohlo být GUI kdykoliv ukončeno a přitom došlo i ke zrušení vláken.
      director.createThreads(scheduleStrategyArray);
    }
    return director;
  }

  /**
   * Uvolní všechny zdroje pro garbage collection.
   * @returns {undefined}
   */
  destroy() {
    const { communicator } = this;
    this.analyticsTracker.off('error', this.onError);
    communicator.off('error', this.onError);
    communicator.off('heartbeatFetched', this.onHeartbeatFetched);
    this.networkListener.off('onlineChanged', this.onOnlineChanged);
    this.replacer.off('content', this.onContentCleaned);
  }

  /**
   * Zruší vytvořený organizátor zobrazování obsahu.
   * @param {ViewerDirector} director
   * @returns {undefined}
   */
  destroyDirector(director) {
    this.viewerDirectorResource.destroy(director);
  }

  /**
   * Spuštění příkazu pro zařízení.
   * @param {CommandEnum} commandEnum Příkaz.
   * @returns {Promise.<undefined>} Vyřeší se po provedení příkazu.
   */
  execute(commandEnum) {
    // TODO Refktorizovat s využitím polymorfismu místo switch.
    // - Vytvořit rozhraní Command s metodou #execute().
    // - Implementovat rozhraní pro každý typ příkazu. V konstruktoru služby, které příkaz provedou.
    // - Vytvořit třídu CommandFactory s metodou #create(commandEnum): Command.
    //   Nebo továrna pro každý typ? Nebo registr příkazů s #register(commandEnum, commandFactory)?
    switch (commandEnum) {
      case CommandEnum.POWER_OFF:
        return this.powerManager.shutdown();
      case CommandEnum.REBOOT:
        return this.powerManager.reboot();
      case CommandEnum.REPORT:
        return this.report();
      default:
        return Promise.reject(
          new RangeError(`Unknown command "${commandEnum}".`)
        );
    }
  }

  /**
   * Získá dodatečné informace pro chybové události.
   * @returns {Promise.<LoggerInfo>} Dodatečné informace.
   */
  getLoggerInfo() {
    return Promise.all([
      this.loggerManager.getInfo().catch((error) => {
        this.logger.error(error);
        return {};
      }),
      new Promise((resolve) => {
        const { session } = this;
        const online = this.networkListener.isOnline();
        return resolve({
          deviceId: session.deviceId,
          online,
          version: session.version
        });
      }).catch((error) => {
        this.logger.error(error);
        return {
          deviceId: null,
          online: null,
          version: null
        };
      })
    ]).then((loggerInfoArray) => Object.assign({}, ...loggerInfoArray));
  }

  /**
   * Zjistí informace o zařízení.
   * @returns {Promise.<ReportInfo>} Informace o zařízení.
   */
  getReportInfo() {
    return this.reportManager
      .getInfo()
      .catch((error) => {
        this.logger.error(error);
        return {};
      })
      .then((reportInfo) => {
        const { session } = this;
        return {
          ...reportInfo,
          buildId: this.buildId,
          contentTimestamp: session.contentTimestamp,
          version: session.version
        };
      });
  }

  /**
   * Zaznamená analytická data.
   * @param {ScheduleInfo} scheduleInfo Informace o přehraném médiu.
   * @returns {Promise.<AnalyticsCounter>} Agregovaná data, do kterých byl proveden záznam.
   */
  hit(scheduleInfo) {
    return this.analyticsTracker.hit(scheduleInfo);
  }

  /**
   * Nainstaluje zařízení a změní jeho spárování se serverem.
   * @param {string} deviceId Identifikátor Ki-Wi zařízení pro spárování.
   * @param {string} serverUrl URL adresa Ki-Wi Server pro spárování.
   * @param {string} fingerprint Otisk zařízení, který se uloží pro spárování.
   * @param {string} storage Uživatelem vybrané úložiště pro ukládání medií.
   * @returns {Promise.<undefined>} Vyřeší se po dokončení instalace.
   */
  install(deviceId, serverUrl, fingerprint, storage) {
    // TODO Store update undefined bug
    // - Nesmí zde dojít ke vložení položky s undefined, jinak se bug projeví.
    // - Metoda update nepřepíše v paměti položky s hodnotou undefined,
    //   ale v perzistentním úložišti ano.
    // - Před jejím voláním se data vloží přes inject.
    //   Zde je ale problém, že se dodržuje identifikátor z attrs a ne z parametrů.
    //   Zatím byl tedy inject níže zakomentovaný, dokud se nenajde lepší řešení.
    // - Asi přepracovat tak, aby se používalo {onConflict: 'replace'}
    const sessionId = this.session.id;
    const attrs = { deviceId, id: sessionId, serverUrl, fingerprint, storage };
    const { store } = this;
    return store.update('session', sessionId, attrs).then(() => {
      this.logger.setInfo({ deviceId });
    });
  }

  /** @inheritdoc */
  off(...args) {
    this.emitter.off(...args);
  }

  /** @inheritdoc */
  on(...args) {
    this.emitter.on(...args);
  }

  /**
   * Reakce na požadavek na zastavení přehrávání obsahu při čištění místa na disku.
   * @param {ContentInfo} contentInfo Prázdný obsah.
   * @private
   * @returns {undefined}
   */
  onContentCleaned(contentInfo) {
    this.cleanContent(contentInfo).catch((error) => this.logger.error(error));
  }

  /**
   * Zareaguje na událost se změnou obsahové úlohy z CRON plánovače.
   * @param {ContentTask|null} contentTask
   * @private
   * @returns {undefined}
   */
  onContentTaskChanged(contentTask) {
    this.setContentTask(contentTask).catch((error) => this.logger.error(error));
  }

  /**
   * Reakce na chybu.
   * @param {Error} error Chybový objekt.
   * @private
   * @returns {undefined}
   */
  onError(error) {
    this.logger.error(error);
  }

  /**
   * Reakce na doručení heartbeatu z Ki-Wi Serveru.
   * @param {HeartbeatFetched} heartbeatFetched Příchozí heartbeat.
   * @private
   * @returns {undefined}
   */
  onHeartbeatFetched(heartbeatFetched) {
    const { deviceId, serverUrl } = this.session;
    const { heartbeatInfo } = heartbeatFetched;

    // Synchronizace fronty příkazů z heartbeat.
    this.communicator
      .fetchCommand(serverUrl, deviceId, heartbeatInfo.queueIdArray)
      .then((commandEnum) => {
        if (isNil(commandEnum)) {
          return;
        }
        return this.execute(commandEnum);
      })
      // Synchronizace obsahu s novým heartbeat timestamp.
      .then(() =>
        this.communicator.fetchContent(
          serverUrl,
          deviceId,
          heartbeatInfo.contentTimestamp
        )
      )
      .then((fetchedContentInfo) => {
        if (isNil(fetchedContentInfo)) {
          // Pokud nebyl nový obsah stažen, tak se provede pouze aktualizace aplikace.
          return this.updater.updateVersion(heartbeatInfo.version);
        }
        // Pokud byl obsah stažen, tak se nahradí za aktuální.
        return this.replacer
          .replace(fetchedContentInfo)
          .then((replacedContentInfo) =>
            // Zastaví se a zruší se CRON, aby změna úlohy nepřerušila změnu obsahu.
            this.unsetContentTasks()
              // Informování zdrojů zobrazování o změně obsahu.
              // Zdroje tak mohou provést údržbu, když je jisté, že žádný není vypůjčený.
              .then(() =>
                this.viewerRegistry
                  .getAll()
                  .reduce(
                    (acc, viewerType) =>
                      acc.then(() => viewerType.getSourceCreator().replace()),
                    Promise.resolve()
                  )
              )
              // Přepnutí analytických intervalů.
              // Provádí se nyní, protože je jisté, že byly všechny slajdy skryté,
              // mělo by se tak předejít následujícímu problému:
              // Pro odeslání se používá událost "left". Některá média mohou "přetékat" do jiných intervalů.
              // Nový obsah = nový interval. Slajd vyvolá "left" až když je již přítomný nový obsah.
              // Chyba nezpůsobí zaseknutí procesu.
              .then(() =>
                this.analyticsTracker
                  .replace()
                  .catch((error) => this.logger.error(error))
              )
              // Nastaví se nový obsah a vyvolá se událost, která o změně informuje.
              // Toto je do větší míry technický dluh, reakce by měla být
              // zpracována lépe, zatím ponechána beze změny tak, jak byla
              // ve strarší verzi implementace bez CRON.
              .then(() => {
                this.contentInfo = replacedContentInfo;
                // Vyvolání události informujícím o novém obsahu.
                this.emitter.emit('content', replacedContentInfo);
              })
              // Spustí se CRON s novým obsahem.
              // Chyba nezpůsobí zaseknutí procesu.
              .then(() =>
                this.setContentTasks(this.contentInfo.contentTasks).catch(
                  (error) => this.logger.error(error)
                )
              )
              // Aktualizace aplikace.
              .then(() => this.updater.updateVersion(heartbeatInfo.version))
              // Aktualizace firmware.
              .then(() => {
                const { firmwareRelease } = replacedContentInfo;
                if (isNil(firmwareRelease)) {
                  // Pokud nebylo vybráno žádné vhodné vydání firmware, tak se aktualizace neprovede.
                  return;
                }
                return this.firmwareManager.update(firmwareRelease);
              })
          );
      })
      .catch((error) => this.logger.error(error));
  }

  /**
   * Reakce na změnu připojení zařízení k síti.
   * @param {boolean} online Příznak, jestli je zařízení online.
   * @private
   * @returns {undefined}
   */
  onOnlineChanged(online) {
    this.logger.setInfo({ online });
  }

  /**
   * Detekuje informace o zařízení a odešle je na server.
   * @returns {Promise.<undefined>} Vyřeší se po úspěšném dokončení.
   */
  report() {
    return this.getReportInfo().then((reportInfo) => {
      const { session } = this;
      return this.communicator.report(
        session.serverUrl,
        session.deviceId,
        reportInfo
      );
    });
  }

  /**
   * Změní aktuálně přehrávanou obsahovou úlohu a spustí jejich plánování.
   * Příčina toho může být jak nový obsah, tak změna úlohy v CRON plánovače.
   * @param {ContentTask|null} contentTask
   * @private
   * @returns {Promise.<undefined>}
   */
  setContentTask(contentTask) {
    return new Promise((resolve) => {
      // Pokud zde nejsou žádná spuštěná vlákna, není třeba nic dělat.
      const viewerDirectors = this.viewerDirectorResource.getAll();
      if (viewerDirectors.length === 0) {
        return resolve();
      }
      // Vytvoří se nové strategie na základě nové obsahové úlohy.
      const scheduleStrategyArray = this.scheduleManager.createStrategies(
        contentTask,
        this.contentInfo
      );
      // Zastaví se všechna vlákna přehrávače a ihned se spustí s novou úlohou.
      return resolve(
        viewerDirectors.reduce(
          (acc, director) =>
            acc.then(() =>
              director
                .destroyThreads()
                .then(() => director.createThreads(scheduleStrategyArray))
            ),
          Promise.resolve()
        )
      );
    });
  }

  /**
   * Nastaví novou sadu aktuálně přehrávaných obsahových úloh.
   * Nepřehrává se více úloh zároveň, ale mohou se střídat v čase,
   * což zajišťuje CRON, který se zároveň spustí.
   * @param {Array.<ContentTask>} contentTasks
   * @private
   * @returns {Promise.<undefined>}
   */
  setContentTasks(contentTasks) {
    return new Promise((resolve) => {
      // Spustí se nový CRON.
      const contentTaskCron = this.startCron(contentTasks);
      // Zjistí se úloha, která se má přehrávat v aktuální okamžik.
      const contentTask = contentTaskCron.getCurrentTask();
      // Zahájení přehrávání vybrané úlohy.
      return resolve(this.setContentTask(contentTask));
    });
  }

  /**
   * Spustí zařízení a obnoví jeho spárování se serverem.
   * Při obnovení se již neprovádí ověření zařízení na serveru. Všechny údaje by měli být před zálohou ověřeny.
   * To ovšem neznamená, že v okamžiku obnovení budou ještě stále platné, ale to že kdysi platné byly.
   * @returns {Promise.<string>} Vrátí nově vygenerovaný nebo aktuální otisk zařízení.
   */
  start() {
    return (
      // Spuštění platformově specifického kódu.
      // Chyba nezpůsobí zaseknutí spuštění.
      this.startupManager
        .start()
        .catch((error) => this.logger.error(error))
        // Obnovení persistentních dat z minulého spuštění.
        .then(() => this.replacer.restore())
        .then((contentInfo) => {
          this.contentInfo = contentInfo;
          // Pokus o stažení chybějícího obsahu. Uvnitř je fronta,
          // takže nebude docházet k nepředvídatelným stavům.
          // Úmyslně se nečeká na výsledek, aby nebyl blokován tok programu.
          this.replacer.restoreMedia(contentInfo);
        })
        // Kontrola informací o aktualizacích z minulého spuštění.
        .then(() => this.updater.start())
        // Přidání dodatečných informací pro logování chyb
        // a datového skladu pro zálohu výjimek.
        // Chyba nezpůsobí zaseknutí spuštění.
        .then(() =>
          this.getLoggerInfo()
            .then((loggerInfo) => this.logger.setInfo(loggerInfo))
            .catch((error) => this.logger.error(error))
        )
        // Zrušení starých již nepoužívaných zdrojů, aby nezabírali místo.
        // Chyba nezpůsobí zaseknutí spuštění.
        .then(() =>
          this.store
            .destroyAll('exception')
            .catch((error) => this.logger.error(error))
        )
        // Inicializace analyzátoru.
        // Chyba nezpůsobí zaseknutí spuštění.
        .then(() =>
          this.analyticsTracker
            .start()
            .catch((error) => this.logger.error(error))
        )
        // Spustí se CRON s novým obsahem.
        // Chyba nezpůsobí zaseknutí procesu.
        // TODO Zbytečné spouštění CRONu při zobrazení Setup Wizard.
        // - Zatím je jednodušší, když je přítomen vždy.
        //   V samotném Setup se použije prázdný obsah, takže se nic nevyvolá.
        //   A i kdyby se vyvolalo, tak zde nejsou vlákna, která by ho přehrála
        //   a nic se tak neudělá.
        // - Změny asi spojit s refaktorizací na ViewerManager apod.
        .then(() =>
          this.setContentTasks(this.contentInfo.contentTasks).catch((error) =>
            this.logger.error(error)
          )
        )
        // Kontrola otisku zařízení.
        // TODO Přesunout do ReplacerFingerprint nebo RaplacerSession?
        .then(() => {
          if (!isNil(this.session.fingerprint)) {
            // Pokud již otisk existuje, vrátí se původní otisk zařízení.
            return this.session.fingerprint;
          }
          // Vygenerování otisku zařízení.
          return this.fingerprintManager.generate();
        })
    );
  }

  /**
   * Vytvoří nový CRON, zahájí sledování ve změnách obsahových úloh.
   * CRON se ukládá do instance a je povoleno mít spuštěný pouze jeden.
   * @param {Array.<ContentTask>} contentTasks
   * @private
   * @returns {ContentTaskCron} Vytvořený CRON
   */
  startCron(contentTasks) {
    if (!isNil(this.contentTaskCron)) {
      throw new Error('CRON is already started.');
    }
    const contentTaskCron = this.contentTaskCronFactory.create(contentTasks);
    this.contentTaskCron = contentTaskCron;
    contentTaskCron.on('taskChanged', this.onContentTaskChanged);
    return contentTaskCron;
  }

  /**
   * Zastaví CRON a ukončí sledování ve změnách obsahových úloh.
   * CRON se ukládá do instance a je povoleno mít spuštěný pouze jeden.
   * @private
   * @returns {undefined}
   */
  stopCron() {
    const { contentTaskCron } = this;
    if (!isNil(contentTaskCron)) {
      contentTaskCron.off('taskChanged', this.onContentTaskChanged);
    }
    this.contentTaskCron = null;
  }

  /**
   * Odebere sadu aktuálně přehrávaných obsahových úloh
   * a zastaví jejich plánování.
   * @private
   * @returns {Promise.<undefined>}
   */
  unsetContentTasks() {
    return new Promise((resolve) => {
      this.stopCron();
      return resolve(
        // Zastaví se všechna vlákna přehrávače.
        this.viewerDirectorResource
          .getAll()
          .reduce(
            (acc, director) => acc.then(() => director.destroyThreads()),
            Promise.resolve()
          )
      );
    });
  }
}

/**
 * Nový obsah zařízení k zobrazení.
 * @event Device#content
 * @param {ContentInfo} contentInfo Informace o novém obsahu zařízení.
 */

export default Device;
